<template>
  <div 
    class="sm-pager"
    :class="canShowMore ? 'right' : ''"
  >

    <paginate
      :style="{'visibility': isMobile || morePages ? 'hidden' : ''}"
      v-model="currentPage"
      :class="pages <= 1 ? 'hidden' : ''"
      :page-count="pages"
      :page-range="pageRange"
      :margin-pages="marginPages"
      :click-handler="paginateHandler"
      :page-class="'sm-pager__pages-item'"
      :container-class="'sm-pager__pages'"
      :next-class="'hidden'"
      :prev-class="'hidden'"
      :disabled-class="'disabled'"
    />
    <btn-block 
      v-if="canShowMore"
      :type="'show'" 
      :text="'Show more'" 
      :icon="'icon-arrow-round'" 
      @click="$emit('showMore')"
    />
    <div 
      
      class="sm-pager__controls"
    >
      <span>
        <span class="sm-txt-strong">{{shownItems.start}}-{{shownItems.finish}}</span> from {{items}}
      </span>

      <dropdown-block 
        v-if="!isMobile && !morePages"
        class="sm-dropdown"
        v-model="value" 
        :options="options"
        :searchable="false"
        :show-labels="false"
        :allow-empty="false"
        @input="changeOnPage(value)"
      >
        <template slot="singleLabel" slot-scope="props">
          <span>
            {{ props.option }} on page
          </span>
          <include-svg :name="'icon-arrow-b'" />
        </template>
        <template slot="option" slot-scope="props">
          <span>
            {{ props.option }} on page
          </span>
        </template>
      </dropdown-block>
    </div>
  </div>
</template>

<script>
import Settings from '@/settings';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import Checkbox from '@/components/Checkboxes';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'paginate-block',
  components: {
    'paginate': Paginate,
    'dropdown-block': Multiselect,
    'checkbox-block': Checkbox
  },
  data () {
    return {
      value: this.onPage,
      options: [8, 12, 24, 48, 96],
      pageRange: 5,
      marginPages: 1,
      currentPage: this.page,
    //  morePages: 0
    }
  },
  props: {
    pages: {
      type: Number,
      default: 1
    },
    page: {
      type: Number,
      default: 1,
    },
    items: {
      type: Number,
      default: 1
    },
    onPage: {
      type: Number,
      default: 8
    },
    morePages: {
      type: Number,
      default: 0
    },
    customOptions: {
      type: Array,
      default: () => []
    }
  },
  created() {
    if (window.innerWidth > Settings.breakpoints.small && window.innerWidth < Settings.breakpoints.medium)
      this.pageRange = 3;

    if (this.customOptions.length)
      this.options = this.customOptions;
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    canShowMore() {
      if (!this.morePages)
        return this.pages > this.page;
      else
        return this.pages > (this.page + this.morePages);
    },
    shownItems() {
      let start = (this.page - 1) * this.onPage + 1;
      let finish = (this.page + this.morePages) * this.onPage;

      if (start > this.items)
        start = this.items;

      if (finish > this.items)
        finish = this.items;

      return {
        start,
        finish 
      }
    }
  },
  methods: {
    updateRouter(obj) {
      let router = this.$route;

      const query = {
        ...router.query, 
        ...obj
      };

      this.$router.push({
        ...router,
        ...{
          query
        }
      });
    },
    paginateHandler(pageNum) {
      this.updateRouter({page: pageNum});
    },
    changeOnPage(value) {
      this.updateRouter({
        limit: value,
        page: 1
      });
    }
  },
  watch: {
    page(val) {
      this.currentPage = val;
    },
    onPage(val) {
      this.value = val;
    }
  }
}
</script>